/**
 * Crea un servicio de respuestas de usuario con el adaptador de API proporcionado.
 * @param {Object} apiAdapter - Debe implementar:
 *   - submitAnswer({ sessionId, pageId, questionId, answerId }) -> Promise<data>
 */
function createUserAnswerService(apiAdapter) {
  return {
    async recordUserAnswer(sessionId, pageId, questionId, answerId) {
      try {
        const data = await apiAdapter.submitAnswer({
          sessionId,
          pageId,
          questionId,
          answerId,
        });
        return { success: true, data };
      } catch (error) {
        console.error("Error registrando respuesta del usuario:", error);
        return {
          success: false,
          error: error.message || "Error al registrar la respuesta",
        };
      }
    },
  };
}

module.exports = { createUserAnswerService };
